import { createAppAsyncThunk } from '../store/extensions';
import {
  deleteFileFromRoomCall,
  deleteFilesFromFeaturedContentCall,
  deleteFilesFromRoomCall,
  deleteVideoAssetCall,
  fetchFeaturedContentFilesCall,
  fetchRoomFileCountCall,
  fetchRoomFilesCall,
  translateDocumentCall,
  updateRoomFileCall,
  uploadFileToFeatureContentCall,
  uploadFileToRoomCall,
  uploadImageCall,
  uploadVideosCall,
} from './service';

export const uploadImage = createAppAsyncThunk(
  'media/uploadImage',
  (formData: unknown) => {
    return uploadImageCall(formData);
  }
);

export const uploadVideos = createAppAsyncThunk(
  'media/uploadVideos',
  (arg: { formData: unknown; roomId: string }) => {
    return uploadVideosCall(arg.formData, arg.roomId);
  }
);

export const deleteVideoAsset = createAppAsyncThunk(
  'media/deleteAsset',
  (arg: { assetName: string; roomId: string }) => {
    return deleteVideoAssetCall(arg.assetName, arg.roomId);
  }
);

export const uploadFileToFeaturedContent = createAppAsyncThunk(
  'media/uploadFileToFeaturedContent',
  (arg: { files: FormData, roomId: string, storyId: string, translationLanguages?: string[] }) => {
    return uploadFileToFeatureContentCall(arg.files, arg.roomId, arg.storyId, arg.translationLanguages);
  }
);

export const deleteFilesFromFeaturedContent = createAppAsyncThunk(
  'media/deleteFilesFromFeaturedContent',
  (arg: { roomId: string, storyId: string, fileIds: string[] }) => {
    return deleteFilesFromFeaturedContentCall(arg.roomId, arg.storyId, arg.fileIds);
  }
);

export const fetchFeaturedContentFiles = createAppAsyncThunk(
  'media/featuredContentFiles',
  (arg: { roomId: string, storyId: string }) => {
    return fetchFeaturedContentFilesCall(arg.roomId, arg.storyId);
  }
);

export const uploadFileToRoom = createAppAsyncThunk(
  'media/uploadFileToRoom',
  (arg: { files: FormData, roomId: string, contentType: string, translationLanguages?: string[] }) => {
    return uploadFileToRoomCall(arg.files, arg.roomId, arg.contentType, arg.translationLanguages);
  }
);

export const deleteFileFromRoom = createAppAsyncThunk(
  'media/deleteFileFromRoom',
  (arg: { roomId: string, fileId: string }) => {
    return deleteFileFromRoomCall(arg.roomId, arg.fileId);
  }
);

export const fetchRoomFiles = createAppAsyncThunk(
  'media/roomFiles',
  (arg: { roomId: string, numrecs?: number }) => {
    return fetchRoomFilesCall(arg.roomId, arg.numrecs);
  }
);

export const deleteFilesFromRoom = createAppAsyncThunk(
  'media/deleteFilesFromRoom',
  (arg: { roomId: string, documentIds: string[] }) => {
    return deleteFilesFromRoomCall(arg.roomId, arg.documentIds);
  }
);

export const fetchRoomFileCount = createAppAsyncThunk(
  'media/fetchRoomFileCount',
  (roomId: string) => {
    return fetchRoomFileCountCall(roomId);
  }
);

export const translateDocument = createAppAsyncThunk(
  'media/translateDocument',
  (arg: { roomId: string, documentId: string, languages: string[] }) => {
    return translateDocumentCall(arg.roomId, arg.documentId, arg.languages);
  }
);

export const updateRoomFile = createAppAsyncThunk(
  'media/updateRoomFile',
  (arg: { roomId: string, documentId: string, data: Record<string, unknown> }) => {
    return updateRoomFileCall(arg.roomId, arg.documentId, arg.data);
  }
);
